import React, { Component } from 'react';
import {ref} from '../../config/firebase';

export default class Awards extends Component {
	constructor(props) {
		super(props);
		this.state = {
			years: [],
			items: []
		};

		this.dbItems = ref.child('awards');
	}

	componentDidMount() {
		this.dbItems.on("value", dataSnapshot => {

			var items = [];
			var years = [];

			dataSnapshot.forEach(function(childSnapshot) {

				years.push(childSnapshot.key);

				dataSnapshot.child(childSnapshot.key).forEach(function(snapshot) {
					var item = snapshot.val();

					item['.year'] = childSnapshot.key;
					item['.key'] = snapshot.key;

					items.push(item);
				});

			});

			this.setState({items, years});

		});

	}

  render() {
  	var _this = this;
    return (

      	<div className="container">
			<div className="row pt50 pb50">
				<div className="col-md-12">
					<h2 className="uppercase pb20"><i className="fa fa-trophy"></i> Awards</h2>
				</div>
				<div className="col-md-12">
					<div id="timeline" className="timeline-container">
						{
							this.state.years.map(function(item) {

								return (
									<div className="timeline-wrapper" key={Math.random()}>
										<h2 className="timeline-time">{item}</h2>
										{
											_this.state.items.map(function (item2) {
												if(item2['.year'] === item) {
													return (
														<dl className="timeline-series" key={item2['.key']}>
															<dt className="timeline-event" id="event01"><a>{item2.name}</a></dt>
															<dd className="timeline-event-content" id="event01EX">
																<p>{item2.description}</p>
															</dd>

														</dl>
													);
												}
												return null;
											})
										}
									</div>
								);
							})
						}

						<br className="clear"/>
					</div>
				</div>
				
			</div>
		</div>

    );
  }
}



// WEBPACK FOOTER //
// ./src/guest/components/Awards.js